var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMlyLogoText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 43,
    viewBox: "0 0 75 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7281 8.12269C32.8491 8.12269 35.7218 11.1373 35.7218 16.4129V31.4021H29.102V17.2502C29.102 15.0312 28.0612 13.9007 25.8129 13.9007C23.4398 13.9007 21.1916 15.3242 21.1916 17.7108V31.4021H14.5302V17.2502C14.5302 15.0312 13.4893 13.9007 11.2828 13.9007C8.90963 13.9007 6.61977 15.3242 6.61977 17.7108V31.4021H0V8.37391H5.912L6.24507 11.0117C7.82715 9.2113 10.4917 8.12269 13.1563 8.12269C16.2788 8.12269 18.3189 9.46251 19.776 11.6816C21.5247 9.50438 24.6056 8.12269 27.7281 8.12269Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1392 31.4021V0H42.2177C44.4269 0 46.2177 1.79086 46.2177 4V31.4021H40.1392Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75 8.37391L61.2609 43H55.3072L60.6363 29.6855H59.2624L50.5193 8.37391H57.0142L63.1344 23.0282L68.7549 8.37391H75Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMlyLogoText);
export default __webpack_public_path__ + "static/media/mly-logo-text.f34d144138bcf6a856b3acd62bdaef37.svg";
export { ForwardRef as ReactComponent };